import { useEffect } from 'react';

/**
 * Custom hook to handle dynamic validations with debouncing
 */

const useDynamicValidations = ({
  data,
  dependencyArray = [],
  dynamicValidations,
  performCustomValidations,
  debounce = 300,
  // fieldId,
}) => {
  useEffect(() => {
    let debounceValidations = null;
    if (dynamicValidations.length > 0 && !!data) {
      debounceValidations = setTimeout(() => {
        if (dynamicValidations.length > 0 && !!data) {
          performCustomValidations({
            inputVal: data,
            validationsToPerform: dynamicValidations,
          });
        }
      }, debounce);
      // console.log(`timer called : ${debounceValidations}  for ${fieldId}`);
    }
    return () => {
      if (debounceValidations) {
        // console.log(`timer cleaned : ${debounceValidations} for  ${fieldId}`);
        clearTimeout(debounceValidations);
      }
    };
  }, [...dependencyArray]);
};

export default useDynamicValidations;
